import API from "@services/root/rootApi";
import {
  WidgetEditionEntity,
  WidgetEntity,
  WidgetScreen,
  WidgetScreenForUpdate,
} from "./types";
import { screensBEtoFE, screensFEtoBE } from "./utils";

const getWidgetRoot = (userId: string) =>
  `/symphony-api/provisioning/user/${userId}/preferences/widgets`;

// Should only be used for updating a single widget, causes data coherence issues otherwise
export const postWidget = async (
  userId: string,
  params: WidgetEditionEntity
): Promise<WidgetEntity> =>
  (await API.post(`${getWidgetRoot(userId)}/`, params, {})).data;

export const postWidgetScreen = async (
  userId: string,
  params: WidgetScreenForUpdate
): Promise<void> =>
  (await API.post(`${getWidgetRoot(userId)}/screens/`, [params], {})).data;

export const postWidgetsScreens = async (
  userId: string,
  params: UserWidgetScreen[]
): Promise<Array<WidgetScreen>> =>
  (
    await API.post(
      `${getWidgetRoot(userId)}/screens/`,
      screensFEtoBE(params, userId),
      {}
    )
  ).data;

export const deleteWidgetScreen = async (userId: string, id: number) =>
  await API.delete(`${getWidgetRoot(userId)}/screens/${id}`);

export const getWidgets = async (
  userId: string
): Promise<UserWidgetScreen[]> => {
  const response = await API.get<WidgetScreen[]>(
    `${getWidgetRoot(userId)}/screens/`
  );
  return screensBEtoFE(response.data);
};
